export const COOKIE_NAME_TOKEN = 'token'